<div id="row7" class="row">
    <div class="graph">
        @if(showCharts) {
        <btw-chart [dataSource]="dataSource">

            @for(serie of series; track serie) {
            <btw-chart-series [name]="serie" [valueField]="serie" type="bar" groupName="group" />
            }

            <btw-chart-argument-axis field="date" type="timeseries">
                <btw-chart-axis-tick format="%Y-%m-%d" />
            </btw-chart-argument-axis>
        </btw-chart>
        }
    </div>
</div>
